import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_THEME } from "../theme/theme";

function Header({ title, showBack = true }) {
  const navigate = useNavigate();
  const [shadow, setShadow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShadow(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className="sticky top-0 left-0 w-full right-0 h-14 flex items-center justify-between px-4 z-[950] max-w-full mx-auto transition-shadow duration-200"
      style={{
        background: APP_THEME.bgColor,
        borderBottom: `1px solid ${APP_THEME.borderColor}`,
        boxShadow: shadow ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
      }}
    >
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate(-1)}
          className="bg-none border-none cursor-pointer p-1 flex items-center"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.textPrimary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </button>
        <span
          className="text-base font-semibold"
          style={{
            color: APP_THEME.textPrimary,
            fontFamily: APP_THEME.fontFamily,
          }}
        >
          {title}
        </span>
      </div>
      <div className="w-[22px]" />
    </header>
  );
}

export default Header;